import React, { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

import { selectHasAuthenticationFailed, selectIsAuthenticated } from 'app/pages/auth/redux/auth-selectors';
import { useAppDispatch } from 'app/hooks/thunk-hooks';
import { authorizeActionCreator } from 'app/pages/auth/redux/action-creators/authorize-action-creator';
import { NavigationService } from 'app/services/navigation-service';
import { Spinner } from 'app/components/spinner';

export const AuthenticatedRoute: FC = () => {
    const isUserAuthenticated = useSelector(selectIsAuthenticated);
    const hasAuthenticationFailed = useSelector(selectHasAuthenticationFailed);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!isUserAuthenticated && !hasAuthenticationFailed) {
            dispatch(authorizeActionCreator());
        }
    }, [dispatch, hasAuthenticationFailed, isUserAuthenticated]);

    if (hasAuthenticationFailed) {
        return <Navigate to={NavigationService.ERROR} replace={true} />;
    }

    if (!isUserAuthenticated) {
        return <Spinner />;
    }

    return <Outlet />;
};
